import { MarketplaceSellerMetaObject, ShopifyProduct } from './types';
import { OnlineProduct } from '../../../../../../packages/apis/src/shopify/types/OnlineProduct';
import { MarketplaceSellerCalloutProps } from '@jbhi-fi/components/src/Marketplace/MarketplaceSellerCallout/MarketplaceSellerCallout';
import { AlgoliaHitTransformer } from '@jbhi-fi/components/src/Algolia/transformers/AlgoliaHitTransformer';

const DEFAULT_VARIANT_TITLE = 'Default Title';

type ShopifyProductTransformerBaseProps = {
  product: ShopifyProduct;
  onlineProduct?: OnlineProduct;
  marketplaceSellers?: Array<MarketplaceSellerMetaObject>;
};

export abstract class ShopifyProductTransformer {
  static isMarketplaceProduct = ({ product }: ShopifyProductTransformerBaseProps): boolean => {
    return product?.variants?.some(variant => variant.title !== DEFAULT_VARIANT_TITLE);
  };

  static toMarketplaceSellerCalloutProps = ({
    product,
    marketplaceSellers,
  }: ShopifyProductTransformerBaseProps):
    | Pick<MarketplaceSellerCalloutProps, 'sellerName' | 'sellerHref'>
    | undefined => {
    const seller = marketplaceSellers?.[0];

    if (!this.isMarketplaceProduct({ product, marketplaceSellers }) || !seller) {
      return undefined;
    }

    return {
      sellerName: seller?.name ?? '',
      sellerHref: seller?.url_handle ? `/collections/${seller?.url_handle}` : undefined,
    };
  };

  static toMarketplaceSeller = ({
    product,
    marketplaceSellers,
    onlineProduct,
  }: ShopifyProductTransformerBaseProps): ReturnType<typeof AlgoliaHitTransformer.toMarketplaceSeller> => {
    const marketplaceSeller = marketplaceSellers?.[0];

    if (!this.isMarketplaceProduct({ product, marketplaceSellers }) || !marketplaceSeller) {
      return undefined;
    }
    const tieredDetails = onlineProduct?.TieredDetails?.filter(
      tieredDetail => `${tieredDetail.Seller.Id}` === `${marketplaceSeller?.seller_id}`
    );

    return {
      name: marketplaceSeller.name,
      id: marketplaceSeller.seller_id,
      tieredIds: tieredDetails?.map(tieredDetail => tieredDetail.Id) ?? [],
      productCondition: {
        code: tieredDetails?.[0]?.Condition?.Code,
        label: tieredDetails?.[0]?.Condition?.Label ?? '',
      },
      isDigitalInvoiceProvided: marketplaceSeller.is_digital_invoice_provided ?? false,
    };
  };
}
